import { FormattedHTMLMessage, FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import tw from 'tailwind.macro';
import { Icon24, Icon40 } from '../../../../components/Icon';
import { P1 } from '../../../../components/P';
import { H2, H3 } from '../../../../components/Typographies/Title';
import { ReactComponent as IconPin } from '../../../../images/illustrated/pin-72.svg';
import { ReactComponent as IconSmile } from '../../../../images/illustrated/smile-48.svg';
import { CONCEPT_BULLETS } from './constants';
import Gallery from './Gallery';
import { homePageConceptMessages } from './messages';

const Container = styled.div`
  ${tw`relative flex flex-col`}
  gap:var(--size-big);

  @media (min-width: 768px) {
    gap: var(--size-huge2);
  }

  @media (min-width: 992px) {
    &:before {
      z-index: -1;
      content: ' ';
      position: absolute;
      background: radial-gradient(
        43.16% 43.16% at 50% 50%,
        rgba(34, 227, 170, 0.15) 0%,
        rgba(215, 243, 229, 0) 100%
      );
      width: 579.2109365188024px;
      left: -348px;
      top: -36px;
      border-radius: 0px;
      bottom: -493px;
      transform: rotate(329deg);
    }

    &:after {
      z-index: -1;
      content: ' ';
      position: absolute;
      background: radial-gradient(
        43.16% 43.16% at 50% 50%,
        rgba(215, 243, 229, 0.6) 0%,
        rgba(215, 243, 229, 0) 100%
      );
      width: 579.2109365188024px;
      right: -303px;
      top: -356px;
      border-radius: 0px;
      bottom: -36px;
    }
  }
`;

const Description = styled.div`
  ${tw`flex flex-col md:px-huge`}
  max-width: 592px;
  gap: var(--size-big);
`;

const Title = styled(H2)`
  ${tw`text-center mx-auto`}
  max-width:600px;

  .highlight {
    ${tw`text-primary-400`}
  }
  span {
    ${tw`relative`}
  }
`;

const TitleIcon = styled(IconSmile)`
  widht: 40px;
  height: 40px;
`;

const SubTitle = styled(H3)`
  span {
    ${tw`relative`}
  }
`;

const SubTitleIcon = styled(IconPin)`
  ${tw`absolute`}
  ${Icon40}
  transform: rotate(52deg);
`;

const P = styled(P1)``;

const List = styled.div`
  ${tw`m-0 flex flex-col`}
  gap:var(--size-medium);
`;

const Bullet = styled.div`
  ${tw`flex items-center`}
  gap:var(--size-small)
`;

const BulletIcon = styled.img`
  ${Icon24}
`;

const Content = styled.div`
  ${tw`flex flex-col lg:flex-row`}
  gap:var(--size-medium2)
`;

const Concept = () => (
  <Container>
    <Title>
      <FormattedHTMLMessage {...homePageConceptMessages.conceptTitle1} />

      <span>
        <FormattedHTMLMessage {...homePageConceptMessages.conceptTitle2} />
        <TitleIcon />
      </span>
    </Title>
    <Content>
      <Description>
        <SubTitle>
          <FormattedMessage {...homePageConceptMessages.conceptSubTitle1} />

          <span>
            <FormattedMessage {...homePageConceptMessages.conceptSubTitle2} />
            <SubTitleIcon />
          </span>
        </SubTitle>
        <P>
          <FormattedHTMLMessage {...homePageConceptMessages.conceptText} />
        </P>
        <List>
          {CONCEPT_BULLETS.map((bullet, index) => (
            <Bullet key={index}>
              <BulletIcon alt={bullet.altMessage} src={bullet.src} />
              <P>
                <FormattedMessage
                  {...homePageConceptMessages[bullet.message]}
                />
              </P>
            </Bullet>
          ))}
        </List>
      </Description>

      <Gallery />
    </Content>
  </Container>
);

export default Concept;
